<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-user"></i> 用户列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 - 优化布局 -->
      <div class="search-bar">
        <!-- 第一行：基础搜索条件 -->
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">用户名</span>
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入用户名"
              clearable
              size="small"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">手机号码</span>
            <el-input 
              v-model="searchForm.mobile" 
              placeholder="请输入手机号码"
              clearable
              size="small"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">所属部门</span>
            <el-cascader
              v-model="searchForm.company_department_id"
              :props="{ value: 'id', label: 'name', checkStrictly: true, emitPath: false }"
              :options="departmentData"
              placeholder="请选择部门"
              clearable
              size="small"
              class="full-width"
            ></el-cascader>
          </div>
          <div class="search-item">
            <span class="search-label">角色名称</span>
            <el-select
              v-model="searchForm.role_name"
              placeholder="请选择角色"
              clearable
              size="small"
              class="full-width"
            >
              <el-option v-for="item in roleNameData"
                         :key="item.role_id"
                         :label="item.name"
                         :value="item.role_id"
              ></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="search-label">状态</span>
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              clearable
              size="small"
              class="full-width"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第二行：操作按钮 -->
        <div class="search-actions">
          <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
          <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
          <el-button type="success" @click="addData" icon="el-icon-plus" size="small">新增用户</el-button>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-user"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总用户数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon active"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ activeCount }}</div>
            <div class="stat-label">启用用户</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon inactive"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ inactiveCount }}</div>
            <div class="stat-label">禁用用户</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          border
          :data="tableLoadData"
          stripe
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="登录账号" min-width="120">
            <template slot-scope="scope">
              <div class="username-cell">
                <i class="el-icon-user"></i>
                <span>{{ scope.row.user_name }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="员工姓名" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.employee ? scope.row.employee.name_cn : '-' }}
            </template>
          </el-table-column>
          
          <el-table-column label="角色" min-width="120">
            <template slot-scope="scope">
              <el-tag 
                v-for="(item, idx) in scope.row.roles" 
                :key="idx"
                size="small"
                type="primary"
                effect="plain"
                class="role-tag"
              >
                {{ item.name }}
              </el-tag>
              <span v-if="!scope.row.roles || scope.row.roles.length === 0">-</span>
            </template>
          </el-table-column>
          
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-switch
                :value="scope.row.status === 1"
                disabled
                active-color="#00b578"
                inactive-color="#ff4d4f"
              ></el-switch>
            </template>
          </el-table-column>
          
          <el-table-column label="创建时间" min-width="160">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="240" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="edit-btn" @click="handelEdit(scope.row)">
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button type="text" size="small" class="password-btn" @click="handelSelect(scope.row)">
                <i class="el-icon-lock"></i> 修改密码
              </el-button>
              <el-button type="text" size="small" class="delete-btn" @click="handelDel(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-user"></i>
        <p>暂无用户数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="560px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right" size="small">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="工号" prop="sn">
                <el-input v-model="form.sn" placeholder="请输入工号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户名" prop="user_name">
                <el-input v-model="form.user_name" placeholder="请输入用户名" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="!isEdit">
            <el-col :span="12">
              <el-form-item label="密码" prop="pass">
                <el-input v-model="form.pass" type="password" placeholder="请输入密码" show-password></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认密码" prop="repass">
                <el-input v-model="form.repass" type="password" placeholder="请再次输入密码" show-password></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="选择员工" prop="employee_id">
            <el-select
              v-model="form.employee_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入搜索员工姓名"
              :remote-method="employeeRemoteMethod"
              :loading="employeeLoading"
              clearable
              class="full-width"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.id"
                :label="item.name_cn"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="角色名称" prop="proxy_role_id">
            <el-select v-model="form.proxy_role_id" placeholder="请选择角色" clearable class="full-width">
              <el-option v-for="item in roleNameData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择状态" class="full-width">
              <el-option label="启用" :value="1"><span style="color: #00b578;">● 启用</span></el-option>
              <el-option label="禁用" :value="0"><span style="color: #ff4d4f;">● 禁用</span></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码弹框 -->
    <el-dialog 
      title="修改密码" 
      :visible.sync="dialogPassword" 
      width="480px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handlePwdDialogClosed"
    >
      <div class="dialog-content">
        <div class="dialog-icon"><i class="el-icon-lock"></i></div>
        <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px" label-position="right">
          <el-form-item label="账号" prop="user_name">
            <el-input v-model="pwdForm.user_name" placeholder="请输入账号" disabled></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="pwdForm.password" type="password" placeholder="请输入新密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="repassword">
            <el-input v-model="pwdForm.repassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelPwdForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitPwdForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hexMD5 } from '../../../utils/md5'
import moment from 'moment'

export default {
  name: "proxyUserList",
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度至少6位'))
      } else {
        if (this.form.repass !== '') this.$refs.form.validateField('repass')
        callback()
      }
    }
    const validateRepass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    const validatePwdRepass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.pwdForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      employeeLoading: false,
      activeCount: 0,
      inactiveCount: 0,
      
      searchForm: {
        name: "",
        mobile: '',
        status: '',
        company_department_id: '',
        role_name: ''
      },
      
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      id: '',
      
      rules: {
        sn: [{ required: false, message: '请输入工号', trigger: 'blur' }],
        user_name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, message: "长度至少3字符", trigger: "blur" }
        ],
        pass: [{ required: true, validator: validatePass, trigger: 'blur' }],
        repass: [{ required: true, validator: validateRepass, trigger: 'blur' }],
        proxy_role_id: [{ required: true, message: '请选择角色', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      
      dialogFormVisible: false,
      dialogTitle: '',
      
      form: {
        id: '',
        sn: "",
        user_name: '',
        proxy_role_id: '',
        status: 1,
        employee_id: '',
        pass: '',
        repass: '',
        proxy_id: sessionStorage.getItem('proxy_id')
      },
      
      departmentData: [],
      roleNameData: [],
      employeeList: [],
      employeeStates: [],
      
      dialogPassword: false,
      pwdForm: { user_name: '', password: '', repassword: '' },
      pwdRules: {
        user_name: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: "密码至少6位", trigger: "blur" }],
        repassword: [{ required: true, validator: validatePwdRepass, trigger: 'blur' }]
      }
    }
  },
  computed: {
    isEdit() { return this.form.id && this.form.id !== '' }
  },
  created() {
    this.DataList()
    this.getEmployeeList()
    this.DepartmentList()
    this.RoleNameList()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    headerCellStyle() { return { background: '#f5f7fa', color: '#1f2d3d', fontWeight: '500', fontSize: '14px', borderBottom: '1px solid #e4e7ed' } },
    rowStyle() { return { cursor: 'pointer' } },
    
    calculateStats() {
      if (!this.tableLoadData || this.tableLoadData.length === 0) {
        this.activeCount = 0
        this.inactiveCount = 0
        return
      }
      this.activeCount = this.tableLoadData.filter(item => item.status === 1).length
      this.inactiveCount = this.tableLoadData.filter(item => item.status === 0).length
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    resetSearch() {
      this.searchForm = { name: "", mobile: '', status: '', company_department_id: '', role_name: '' }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    getEmployeeList() {
      const param = { company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') }
      this.$axios.proxyEmployeeListP(param).then(res => {
        if (res.code == 200) this.employeeList = res.data.data|| []
      }).catch(error => console.log(error))
    },
    
    employeeRemoteMethod(query) {
      if (query !== '') {
        this.employeeLoading = true
        const param = { keywords: query, company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') }
        this.$axios.proxyEmployeeListP(param).then(res => {
          if (res.code == 200) this.employeeList = res.data.data || []
          this.employeeLoading = false
        }).catch(() => { this.employeeLoading = false })
      }
    },
    
    DepartmentList() {
      const param = { company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') }
      this.$axios.departmentTree(param).then(res => {
        if (res.code == 200) this.departmentData = res.data || []
      }).catch(error => console.log(error))
    },
    
    RoleNameList() {
      const param = { company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token'), proxy_id: sessionStorage.getItem('proxy_id') }
      this.$axios.getProxyRoleList(param).then(res => {
        if (res.code == 200) this.roleNameData = res.data || []
      })
    },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        page: this.pageNum,
        pageSize: this.pageSize,
        proxy_id: sessionStorage.getItem('proxy_id'),
      }
      if (this.searchForm.name) param.name = this.searchForm.name
      if (this.searchForm.mobile) param.mobile = this.searchForm.mobile
      if (this.searchForm.status !== '') param.status = this.searchForm.status
      if (this.searchForm.company_department_id) param.department_id = this.searchForm.company_department_id
      if (this.searchForm.role_name) param.role_id = this.searchForm.role_name
      
      this.$axios.getProxyUserListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => { this.loading = false; console.log(error) })
    },
    
    handleSizeChange(newSize) { this.pageSize = newSize; this.pageNum = 1; this.DataList() },
    handleCurrentChange(newPage) { this.pageNum = newPage; this.DataList() },
    searchSubmit() { this.pageNum = 1; this.DataList() },
    
    addData() {
      this.dialogTitle = '新增用户'
      this.id = ''
      this.form = { id: '', sn: "", user_name: '', proxy_role_id: '', status: 1, employee_id: '', pass: '', repass: '', proxy_id: sessionStorage.getItem('proxy_id') }
      this.dialogFormVisible = true
    },
    
    handelEdit(row) {
      this.dialogTitle = '编辑用户'
      this.id = row.id
      this.form = { id: row.id, sn: row.sn || '', user_name: row.user_name, proxy_role_id: row.roles && row.roles.length > 0 ? row.roles[0].id : '', status: row.status, employee_id: row.employee_id || '', pass: '', repass: '', proxy_id: sessionStorage.getItem('proxy_id') }
      this.dialogFormVisible = true
    },
    
    handelDel(row) {
      this.$confirm(`确定要删除用户"${row.user_name}"吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true
      }).then(() => {
        const param = { company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token'), id: row.id }
        this.$axios.userDel(param).then(res => {
          if (res.code == 200) { this.$message.success(res.msg); this.DataList() }
          else { this.$message.error(res.msg) }
        }).catch(error => { console.log(error); this.$message.error('删除失败') })
      }).catch(() => { this.$message.info('已取消删除') })
    },
    
    handleDialogClosed() { this.$refs.form?.resetFields() },
    cancelForm() { this.dialogFormVisible = false },
    
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = { sn: this.form.sn, user_name: this.form.user_name, role_id: this.form.proxy_role_id, status: this.form.status, company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token'), proxy_id: this.form.proxy_id }
          if (this.form.employee_id) param.employee_id = this.form.employee_id
          if (this.id) {
            param.id = this.id
            this.$axios.proxyUserUpdate(param).then(res => {
              if (res.code == 200) { this.$message.success(res.msg); this.DataList(); this.dialogFormVisible = false }
              else { this.$message.error(res.msg) }
            })
          } else {
            param.pass = hexMD5(this.form.pass); param.repass = hexMD5(this.form.repass)
            this.$axios.proxyUserSave(param).then(res => {
              if (res.code == 200) { this.$message.success(res.msg); this.DataList(); this.dialogFormVisible = false }
              else { this.$message.error(res.msg) }
            })
          }
        }
      })
    },
    
    handelSelect(row) { this.id = row.id; this.pwdForm.user_name = row.user_name; this.pwdForm.password = ''; this.pwdForm.repassword = ''; this.dialogPassword = true },
    handlePwdDialogClosed() { this.$refs.pwdForm?.resetFields() },
    cancelPwdForm() { this.dialogPassword = false },
    submitPwdForm() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          const param = { id: this.id, password: hexMD5(this.pwdForm.password), repassword: hexMD5(this.pwdForm.repassword), company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') }
          this.$axios.proxyUserChangePsw(param).then(res => {
            if (res.code == 200) { this.$message.success(res.msg); this.dialogPassword = false }
            else { this.$message.error(res.msg) }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式 - 优化布局
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .search-label {
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
      min-width: 80px;
      text-align: right;
    }
    
    .el-input, .el-select, .el-cascader {
      width: 180px;
    }
  }
  
  .full-width {
    width: 180px;
  }
  
  .search-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-start;
    
    .el-button {
      border-radius: 20px;
      padding: 8px 20px;
    }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; border-color: #1acd8c; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 150px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.active { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.inactive { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    }
    
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.username-cell { display: flex; align-items: center; gap: 6px; i { color: #1677ff; } }
.role-tag { margin-right: 4px; margin-bottom: 2px; }
.time-text { font-size: 12px; color: #8c8f98; }

.edit-btn { color: #1677ff; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #4096ff; } }
.password-btn { color: #e6a23c; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #ebb563; } }
.delete-btn { color: #ff4d4f; i { margin-right: 4px; } &:hover { color: #ff7875; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pager li.active { background: #1677ff; color: #fff; } }

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}

.dialog-icon { text-align: center; margin-bottom: 20px; i { font-size: 56px; color: #1677ff; background: #e6f4ff; padding: 16px; border-radius: 60px; } }
.full-width { width: 100%; }

.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 24px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}

// 响应式
@media (max-width: 1200px) {
  .search-bar .search-item .el-input,
  .search-bar .search-item .el-select,
  .search-bar .search-item .el-cascader,
  .search-bar .full-width { width: 150px; }
  .search-bar .search-item .search-label { min-width: 70px; }
}

@media (max-width: 992px) {
  .search-bar .search-row { flex-direction: column; gap: 12px; }
  .search-bar .search-item { width: 100%; .el-input, .el-select, .el-cascader, .full-width { flex: 1; } }
}
</style>